import { type ReactNode, type FC, useEffect } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { useBreakpointContext } from "@/contexts/BreakpointContext";

interface DrawerProps {
  direction?: "left" | "right";
  isOpen: boolean;
  children: ReactNode;
  onToggle: (isOpen: boolean) => void;
}

const Drawer: FC<DrawerProps> = ({
  direction = "left",
  children,
  isOpen,
  onToggle,
}) => {
  const { isDesktop } = useBreakpointContext();
  const isLeft = direction === "left";

  useEffect(() => {
    if (isDesktop) {
      onToggle(false);
    }
  }, [isDesktop, onToggle]);

  return (
    <div
      className={clsx(
        "fixed inset-y-0 left-0 right-0 z-50 bg-black transition-opacity",
        {
          "pointer-events-auto bg-opacity-70": isOpen,
          "pointer-events-none opacity-0": !isOpen,
        },
      )}
      onClick={() => onToggle(false)}
    >
      <div
        className={clsx(
          "absolute inset-y-0 w-80 bg-white transition-transform duration-300",
          {
            "left-0 translate-x-0": isLeft && isOpen,
            "left-0 -translate-x-full": isLeft && !isOpen,
            "right-0 translate-x-0": !isLeft && isOpen,
            "right-0 translate-x-full": !isLeft && !isOpen,
          },
        )}
      >
        <div className="flex h-14 justify-end">
          <button onClick={() => onToggle(false)}>
            <XMarkIcon className="box-content size-6 p-2" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Drawer;
